import Vue from 'vue';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import router from './router';
import store from './store';
import App from './App.vue';
import './icons';

Vue.use(preview);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#nxin');
